import React from "react";
import contextProvider from "../../../contextProvider";
import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import ReactOButton from "../../../_L1_components/Elements/ReactOButton";
import ReactOCollapse from "../../../_L1_components/Elements/ReactOCollapse";
import ReactOTooltip from "../../../_L1_components/Elements/ReactOTooltip";
import Panel from "../../../_L1_components/Layout/Panel";

class ListView extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
      _collapse_controllers: {},
    };
    super(props, initState);
  }

  onComponentDidMount() {
    // console.log(" this.props", this.props);
  }

  formatMBytes(val) {
    parseFloat(val);
    let number = val / 1000000;
    return Math.round((number + Number.EPSILON) * 100) / 100;
  }

  onRender() {
    return (
      <div>
        <Row
          noGutters
          className="px-3 py-2 border-bottom border-top border-gray300 measure-result-details-viewer-header"
        >
          <Col
            xs={this.getAppContext().media.isMobile ? 2 : 1}
            className={
              this.getAppContext().media.isMobile ? "mr-1" : "header-status"
            }
          >
            <div className="sub-title">
              <strong>STATUS</strong>
            </div>
          </Col>
          <Col xs={3} className="header-phase">
            <div className="sub-title">
              <strong>STEP</strong>{" "}
            </div>
          </Col>
          <Col
            xs={this.getAppContext().media.isMobile ? 4 : 2}
            className="header-time text-right"
          >
            <div className="sub-title">
              <strong>TIME</strong>
            </div>
          </Col>
          <Col
            xs={this.getAppContext().media.isMobile ? 3 : 5}
            className="header-note px-4"
          >
            <div className="sub-title">
              <strong></strong>
            </div>
          </Col>
          <Col className="header-collapse-indicator" />
        </Row>

        {this.props.listData.summary.steps.map((_CURR_phase, _CURR_idx) => {
          let discearly = false;
          if (
            this.props.listData.summary.discearly &&
            this.props.listData.summary.discearly == _CURR_phase[0]
          ) {
            discearly = true;
          }
          let className = { col: "", row: " heading" };
          let _TMP_filtered = [];
          if (_CURR_phase[1] != "nan") {
            _TMP_filtered = this.props.listData.steps.filter((value) => {
              let re = new RegExp(
                "(^" +
                  _CURR_phase[0] +
                  "$)|(^" +
                  _CURR_phase[0] +
                  "\\s\\-\\s.*$)"
              );
              return re.test(value.name);
            });
          }

          if (_TMP_filtered.length > 1) {
            _TMP_filtered.unshift({
              name: _CURR_phase[0],
              result: "_HEADING_",
            });
          }

          // Col classname
          if (!/^-$/.test(_CURR_phase[1])) {
            if (_CURR_phase[1] == "nan") {
              className.col = "icon-minus text-gray500";
            } else if (/^(\d+)$/.test(_CURR_phase[1])) {
              className.col = "icon-check1 text-success";
            } else {
              className.col = "icon-close-outline text-danger";
            }
          }
          return (_TMP_filtered.length ? _TMP_filtered : [{ name: false }]).map(
            (_C_detail_step, _C_detail_idx) => {
              // Row classname
              if (_C_detail_step.result != "_HEADING_") {
                if (!/^-$/.test(_CURR_phase[1])) {
                  if (_CURR_phase[1] == "nan") {
                    className.row = "not-available";
                  } else if (
                    this.state._collapse_controllers[
                      this.props.listData.etime + "_" + _C_detail_step.name
                    ] &&
                    this.state._collapse_controllers[
                      this.props.listData.etime + "_" + _C_detail_step.name
                    ].opened
                  ) {
                    className.row = "opened";
                  } else {
                    className.row = "";
                  }
                } else {
                  className.row = "not-available";
                }
              }
              return (
                <Row
                  key={_CURR_idx + "." + _C_detail_idx}
                  noGutters
                  className="phase-row border-bottom border-gray300"
                >
                  <Col>
                    <Row
                      id={
                        "tp_" +
                        _CURR_idx.toString() +
                        "_" +
                        _C_detail_idx.toString()
                      }
                      style={
                        _C_detail_step.result &&
                        _C_detail_step.result != "_HEADING_" &&
                        !discearly
                          ? { cursor: "pointer" }
                          : {}
                      }
                      noGutters
                      className={"phase-row-header " + className.row}
                      onClick={() => {
                        if (
                          this.state._collapse_controllers[
                            this.props.listData.etime +
                              "_" +
                              _C_detail_step.name
                          ]
                        ) {
                          this.state._collapse_controllers[
                            this.props.listData.etime +
                              "_" +
                              _C_detail_step.name
                          ].toggle();
                        }
                      }}
                    >
                      {_CURR_phase[1] == "nan" && (
                        <ReactOTooltip
                          placement="bottom"
                          target={
                            "tp_" +
                            _CURR_idx.toString() +
                            "_" +
                            _C_detail_idx.toString()
                          }
                          text="Step not configured to run in this instant"
                          delay={{ show: 200 }}
                        />
                      )}
                      <Col
                        xs={this.getAppContext().media.isMobile ? 2 : 1}
                        className="header-status align-self-center"
                      >
                        {_C_detail_idx > 0 ? (
                          <strong>. . .</strong>
                        ) : (
                          <span className={"title-1 " + className.col} />
                        )}
                      </Col>
                      <Col
                        xs={this.getAppContext().media.isMobile ? 4 : 3}
                        className="header-phase align-self-center text-truncate"
                      >
                        {_C_detail_step.name
                          ? _C_detail_step.name
                          : _CURR_phase[0]}
                      </Col>
                      <Col
                        xs={this.getAppContext().media.isMobile ? 3 : 2}
                        className="header-time align-self-center text-right"
                      >
                        {_C_detail_idx === 0 ? (
                          !/^-$/.test(_CURR_phase[1]) &&
                          _C_detail_step.result ? (
                            <span>
                              {/^(\d+)$/.test(_CURR_phase[1])
                                ? _CURR_phase[1]
                                : "-"}{" "}
                              ms
                            </span>
                          ) : _CURR_phase[1] == "nan" ? (
                            "-"
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </Col>

                      {this.props.listData.summary.discearly ==
                      _CURR_phase[0] ? (
                        <Col
                          style={{ marginLeft: "-5em" }}
                          className="header-note align-self-center"
                        >
                          <span className="text-danger">
                            Early disconnected by AP
                          </span>
                        </Col>
                      ) : null}
                      {!this.getAppContext().media.isMobile ? (
                        <Col className="header-collapse-indicator align-self-center">
                          <span
                            className="text-muted mt-3 pr-2"
                            style={{ fontSize: "18px" }}
                          >
                            {/^TIME FROM:/gm.test(_C_detail_step.result) ||
                            _C_detail_step.result == "_HEADING_" ||
                            _C_detail_step.harid ||
                            _C_detail_step.jpegid ||
                            parseInt(_CURR_phase[1]) == 0 ? null : (
                              <span>
                                {this.state._collapse_controllers[
                                  this.props.listData.etime +
                                    "_" +
                                    _C_detail_step.name
                                ] &&
                                this.state._collapse_controllers[
                                  this.props.listData.etime +
                                    "_" +
                                    _C_detail_step.name
                                ].opened ? (
                                  <span
                                    className="icon-new-tab button-card pl-2"
                                    // size="lg"
                                    // color="secondary"
                                    // icon="new-tab"
                                    // text
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      let _toSend = {
                                        api: {
                                          probeuid:
                                            this.props.match.params.probeuid,
                                          measureid:
                                            this.props.match.params.measureid,
                                          bssid: this.props.match.params.bssid,
                                          ts: this.props.match.params.ts,
                                        },
                                        ref: {
                                          name: _C_detail_step.name,
                                          phase: _CURR_phase,
                                          selectedResult:
                                            this.props.selectedResult,
                                          originUrl: this.props.match.url,
                                          final: false,
                                        },
                                      };
                                      this.props.viewStep(_toSend);
                                    }}
                                  />
                                ) : null}
                              </span>
                            )}

                            {_C_detail_step.result != "_HEADING_" &&
                              _C_detail_step.mp4id && (
                                <span
                                  title="Play video"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    // let chromiumSize;
                                    let _TMP_split =
                                      _C_detail_step.result.split("|");
                                    _TMP_split.forEach((_C_data) => {
                                      // let _TMP_regex_res = /^\s*SIZE:\s(.*)\s*$/.exec(
                                      //   _C_data
                                      // );
                                      // if (_TMP_regex_res) {
                                      //   chromiumSize = parseFloat(
                                      //     _TMP_regex_res[1]
                                      //   ).toFixed(1);
                                      // }
                                    });
                                    let chromiumVideo =
                                      _C_detail_step.mp4id &&
                                      this.getAppContext().momentjs().unix() -
                                        this.props.match.params.ts <
                                        86400 * 60
                                        ? this.props.listData.res_id +
                                          "." +
                                          _C_detail_step.mp4id +
                                          ".mp4"
                                        : undefined;

                                    let objVideo = {
                                      url:
                                        this.getAppContext()
                                          .getApiStoreService()
                                          .getCluster() +
                                        this.getAppContext().conf.API_PATH +
                                        "/utils/chromescreenstream/" +
                                        this.props.match.params.probeuid +
                                        "/" +
                                        this.props.match.params.measureid +
                                        "/" +
                                        this.props.listData.bssid.replace(
                                          /:/g,
                                          ""
                                        ) +
                                        "/" +
                                        chromiumVideo +
                                        "?token=" +
                                        this.getAppContext().authHandler.getToken(),
                                      chromiumVideo: chromiumVideo,
                                      bssid: this.props.listData.bssid.replace(
                                        /:/g,
                                        ""
                                      ),
                                      // size: chromiumSize,
                                    };
                                    this.props._overlap_modal_video.open(
                                      objVideo
                                    );
                                  }}
                                  className="icon-file-video button-card pl-2"
                                />
                              )}
                            {/* lmp4 */}
                            {_C_detail_step.result != "_HEADING_" &&
                              _C_detail_step.lmp4id && (
                                <span
                                  title="Play video"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    // let chromiumSize;
                                    let _TMP_split =
                                      _C_detail_step.result.split("|");
                                    _TMP_split.forEach((_C_data) => {
                                      // let _TMP_regex_res = /^\s*SIZE:\s(.*)\s*$/.exec(
                                      //   _C_data
                                      // );
                                      // if (_TMP_regex_res) {
                                      //   chromiumSize = parseFloat(
                                      //     _TMP_regex_res[1]
                                      //   ).toFixed(1);
                                      // }
                                    });
                                    let chromiumLmp4 =
                                      _C_detail_step.lmp4id &&
                                      this.getAppContext().momentjs().unix() -
                                        this.props.match.params.ts <
                                        86400 * 60
                                        ? this.props.listData.res_id +
                                          "." +
                                          _C_detail_step.lmp4id +
                                          ".lmp4"
                                        : undefined;

                                    let lmp4URL =
                                      this.getAppContext()
                                        .getApiStoreService()
                                        .getCluster() +
                                      this.getAppContext().conf.API_PATH +
                                      "/utils/chromescreenstream/" +
                                      this.props.match.params.probeuid +
                                      "/" +
                                      this.props.match.params.measureid +
                                      "/" +
                                      this.props.listData.bssid.replace(
                                        /:/g,
                                        ""
                                      ) +
                                      "/" +
                                      chromiumLmp4 +
                                      "?token=" +
                                      this.getAppContext().authHandler.getToken();
                                    fetch(lmp4URL)
                                      .then((response) => response.text())
                                      .then((url) => {
                                        let parsedURL = "https://" + url;
                                        let objVideo = {
                                          url: parsedURL,
                                          chromiumLmp4: chromiumLmp4,
                                          bssid:
                                            this.props.listData.bssid.replace(
                                              /:/g,
                                              ""
                                            ),
                                          // size: chromiumSize,
                                        };
                                        this.props._overlap_modal_video.open(
                                          objVideo
                                        );
                                      });
                                  }}
                                  className="icon-file-video button-card pl-2"
                                />
                              )}

                            {_C_detail_step.result != "_HEADING_" &&
                              _C_detail_step.screendocid && (
                                <span
                                  title={
                                    _C_detail_step.screendoctitle ||
                                    "View image"
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    let chromiumPng = _C_detail_step.screendocid
                                      ? this.props.listData.res_id +
                                        "." +
                                        _C_detail_step.screendocid +
                                        ".png"
                                      : undefined;

                                    let objPng = {
                                      url:
                                        this.getAppContext()
                                          .getApiStoreService()
                                          .getCluster() +
                                        this.getAppContext().conf.API_PATH +
                                        "/utils/chromescreenstream/" +
                                        this.props.match.params.probeuid +
                                        "/" +
                                        this.props.match.params.measureid +
                                        "/" +
                                        this.props.listData.bssid.replace(
                                          /:/g,
                                          ""
                                        ) +
                                        "/" +
                                        chromiumPng +
                                        "?token=" +
                                        this.getAppContext().authHandler.getToken(),
                                      chromiumJpeg: chromiumPng,
                                      bssid: this.props.listData.bssid.replace(
                                        /:/g,
                                        ""
                                      ),
                                      screendoctitle:
                                        _C_detail_step.screendoctitle ||
                                        undefined,
                                    };

                                    this.props._overlap_modal_screen.open(
                                      objPng
                                    );
                                  }}
                                  className="icon-picture button-card pl-2"
                                />
                              )}

                            {_C_detail_step.result != "_HEADING_" &&
                              _C_detail_step.logcatid && (
                                <span
                                  title="View .logcat"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let chromiumLogcat =
                                      this.props.listData.res_id +
                                      "." +
                                      _C_detail_step.logcatid +
                                      ".logcat";
                                    this.props.viewLogcat(
                                      this.props.listData.bssid.replace(
                                        /:/g,
                                        ""
                                      ),
                                      chromiumLogcat
                                    );
                                  }}
                                  className="icon-file-log button-card pl-2"
                                />
                              )}
                            {_C_detail_step.result != "_HEADING_" &&
                              _C_detail_step.harid && (
                                <span
                                  title="View .har"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let chromiumHar =
                                      this.props.listData.res_id +
                                      "." +
                                      _C_detail_step.harid +
                                      ".har";
                                    this.props.viewHar(
                                      this.props.listData.bssid.replace(
                                        /:/g,
                                        ""
                                      ),
                                      chromiumHar
                                    );
                                  }}
                                  className="icon-file-har button-card pl-2"
                                />
                              )}

                            {_C_detail_step.result != "_HEADING_" &&
                              _C_detail_step.pdfid && (
                                <span
                                  title="Download .pdf"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    // let chromiumSize;
                                    let _TMP_split =
                                      _C_detail_step.result.split("|");
                                    _TMP_split.forEach((_C_data) => {
                                      // let _TMP_regex_res = /^\s*SIZE:\s(.*)\s*$/.exec(
                                      //   _C_data
                                      // );
                                      // if (_TMP_regex_res) {
                                      //   chromiumSize = parseFloat(
                                      //     _TMP_regex_res[1]
                                      //   ).toFixed(1);
                                      // }
                                    });
                                    let chromiumPDF = _C_detail_step.pdfid
                                      ? this.props.listData.res_id +
                                        "." +
                                        _C_detail_step.pdfid +
                                        ".pdf"
                                      : undefined;
                                    let objPDF = {
                                      url:
                                        this.getAppContext()
                                          .getApiStoreService()
                                          .getCluster() +
                                        this.getAppContext().conf.API_PATH +
                                        "/utils/chromepdfstream/" +
                                        this.props.match.params.probeuid +
                                        "/" +
                                        this.props.match.params.measureid +
                                        "/" +
                                        this.props.listData.bssid.replace(
                                          /:/g,
                                          ""
                                        ) +
                                        "/" +
                                        chromiumPDF +
                                        "?token=" +
                                        this.getAppContext().authHandler.getToken(),
                                      chromiumPDF: chromiumPDF,
                                      bssid: this.props.listData.bssid.replace(
                                        /:/g,
                                        ""
                                      ),
                                      // size: chromiumSize,
                                    };
                                    window.open(objPDF.url);
                                  }}
                                  className="icon-file-pdf1 button-card pl-2"
                                />
                              )}

                            {_TMP_filtered.length > 1 &&
                            _C_detail_idx == 0 ? null : (
                              <span
                                className={
                                  "title-2 text-muted pl-4 " +
                                  (!/^-$/.test(_CURR_phase[1]) &&
                                  _C_detail_step.result
                                    ? this.state._collapse_controllers[
                                        this.props.listData.etime +
                                          "_" +
                                          _C_detail_step.name
                                      ] &&
                                      this.state._collapse_controllers[
                                        this.props.listData.etime +
                                          "_" +
                                          _C_detail_step.name
                                      ].opened
                                      ? "icon-caret-up-outline"
                                      : "icon-caret-down-outline"
                                    : "")
                                }
                              />
                            )}
                          </span>
                        </Col>
                      ) : (
                        <Col className="text-right">
                          {/^TIME FROM:/gm.test(_C_detail_step.result) ||
                          _C_detail_step.result == "_HEADING_" ||
                          _C_detail_step.harid ||
                          _C_detail_step.jpegid ||
                          parseInt(_CURR_phase[1]) == 0 ? null : (
                            <span>
                              {this.state._collapse_controllers[
                                this.props.listData.etime +
                                  "_" +
                                  _C_detail_step.name
                              ] &&
                              this.state._collapse_controllers[
                                this.props.listData.etime +
                                  "_" +
                                  _C_detail_step.name
                              ].opened ? (
                                <span
                                  className="icon-new-tab button-card pl-2"
                                  // size="lg"
                                  // color="secondary"
                                  // icon="new-tab"
                                  // text
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let _toSend = {
                                      api: {
                                        probeuid:
                                          this.props.match.params.probeuid,
                                        measureid:
                                          this.props.match.params.measureid,
                                        bssid: this.props.match.params.bssid,
                                        ts: this.props.match.params.ts,
                                      },
                                      ref: {
                                        name: _C_detail_step.name,
                                        phase: _CURR_phase,
                                        selectedResult:
                                          this.props.selectedResult,
                                        originUrl: this.props.match.url,
                                        final: false,
                                      },
                                    };
                                    this.props.viewStep(_toSend);
                                  }}
                                />
                              ) : null}
                            </span>
                          )}
                          {_TMP_filtered.length > 1 &&
                          _C_detail_idx == 0 ? null : (
                            <span
                              className={
                                "title-2 text-muted pl-2 " +
                                (!/^-$/.test(_CURR_phase[1]) &&
                                _C_detail_step.result
                                  ? this.state._collapse_controllers[
                                      this.props.listData.etime +
                                        "_" +
                                        _C_detail_step.name
                                    ] &&
                                    this.state._collapse_controllers[
                                      this.props.listData.etime +
                                        "_" +
                                        _C_detail_step.name
                                    ].opened
                                    ? "icon-caret-up-outline"
                                    : "icon-caret-down-outline"
                                  : "")
                              }
                            />
                          )}
                        </Col>
                      )}
                    </Row>
                    {_C_detail_step.result &&
                    _C_detail_step.result != "_HEADING_" &&
                    !/^-$/.test(_CURR_phase[1]) ? (
                      <ReactOCollapse
                        key={
                          this.props.listData.etime +
                          "." +
                          _CURR_idx +
                          "." +
                          _C_detail_idx +
                          ".2"
                        }
                        className="phase-row-body"
                        onControllerReady={(_collapse_controller) => {
                          this.setState((prev_state) => {
                            prev_state._collapse_controllers[
                              this.props.listData.etime +
                                "_" +
                                _C_detail_step.name
                            ] = _collapse_controller;
                            return prev_state;
                          });
                        }}
                        initOpen={
                          _CURR_phase[1] != "nan" &&
                          !/^(\d+)$/.test(_CURR_phase[1])
                        }
                        onOpened={() => {
                          this.setState((prev_state) => {
                            prev_state._collapse_controllers[
                              this.props.listData.etime +
                                "_" +
                                _C_detail_step.name
                            ].opened = true;
                            return prev_state;
                          });
                        }}
                        onClosed={() => {
                          this.setState((prev_state) => {
                            prev_state._collapse_controllers[
                              this.props.listData.etime +
                                "_" +
                                _C_detail_step.name
                            ].opened = false;
                            return prev_state;
                          });
                        }}
                      >
                        {(() => {
                          // console.log("_C_detail_step", _C_detail_step);
                          let _TMP_step_result = _C_detail_step.result;
                          let isChromium = false;
                          let chromiumInfo = [];
                          let chromiumTimeFrom = "";
                          let chromiumTimeTo = "";
                          let chromiumTime = "";
                          let chromiumSize = "";
                          let chromiumMsg = "";
                          let chromiumError = "";
                          let chromiumExtraInfo = "";
                          let chromiumBytesIn = "";
                          let chromiumBytesOut = "";
                          let chromiumHar = null;
                          let chromiumLogcat = null;
                          let chromiumJpeg = null;
                          let chromiumVideo = null;
                          let chromiumPDF = null;
                          let lmp4URL = undefined;
                          let chromiumLmp4;
                          if (
                            _C_detail_step.jpegid ||
                            /^TIME FROM:/gm.test(_C_detail_step.result)
                          ) {
                            isChromium = true;
                            let _TMP_split = _C_detail_step.result.split("|");
                            let _REGEXs = [
                              {
                                name: "TIME FROM",
                                regex: /^\s*TIME\sFROM:\s(.*)\s*$/,
                              },
                              {
                                name: "TIME TO",
                                regex: /^\s*TIME\sTO:\s(.*)\s*$/,
                              },
                              {
                                name: "TIME",
                                regex: /^\s*TIME:\s(.*)\s*$/,
                              },
                              {
                                name: "SIZE",
                                regex: /^\s*SIZE:\s(.*)\s*$/,
                              },
                              {
                                name: "MSG",
                                regex: /^\s*MSG:\s(.*)\s*$/,
                              },
                              {
                                name: "ERROR",
                                regex: /^\s*ERROR:\s(.*)\s*$/,
                              },
                              {
                                name: "BYTESIN",
                                regex: /^\s*BYTESIN:\s(.*)\s*$/,
                              },
                              {
                                name: "BYTESOUT",
                                regex: /^\s*BYTESOUT:\s(.*)\s*$/,
                              },
                            ];
                            _TMP_split.forEach((_C_data) => {
                              _REGEXs.every((_C_regex) => {
                                let _TMP_regex_res =
                                  _C_regex.regex.exec(_C_data);
                                if (_TMP_regex_res) {
                                  if (_C_regex.name == "TIME FROM") {
                                    chromiumTimeFrom = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Time from:{" "}
                                          <strong>{chromiumTimeFrom}</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "TIME TO") {
                                    chromiumTimeTo = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Time to:{" "}
                                          <strong>{chromiumTimeTo}</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "TIME") {
                                    chromiumTime = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Elapsed time:{" "}
                                          <strong>{chromiumTime} ms</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "SIZE") {
                                    chromiumSize = parseFloat(
                                      _TMP_regex_res[1]
                                    ).toFixed(1);
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Downloaded size:{" "}
                                          <strong>{chromiumSize}K</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "MSG") {
                                    chromiumMsg = _TMP_regex_res[1];
                                  } else if (_C_regex.name == "ERROR") {
                                    chromiumError = _TMP_regex_res[1];
                                  } else if (_C_regex.name == "BYTESIN") {
                                    chromiumBytesIn = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          MBytes IN:{" "}
                                          <strong>
                                            {this.formatMBytes(chromiumBytesIn)}
                                          </strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "BYTESOUT") {
                                    chromiumBytesOut = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          MBytes OUT:{" "}
                                          <strong>
                                            {this.formatMBytes(
                                              chromiumBytesOut
                                            )}
                                          </strong>
                                        </div>
                                      ),
                                    });
                                  }
                                  return false;
                                }
                                return true;
                              });
                            });
                            _TMP_split.forEach((str) => {
                              // console.log("word", str.includes("INFO"), str);
                              const errorMatch = str.match(
                                /ERROR:\s*([\s\S]*?)(?=====|$)/
                              );
                              const infoMatch = str.match(/INFO:\s*(.*)/);

                              const error = errorMatch
                                ? errorMatch[1].trim()
                                : "";
                              const info = infoMatch ? infoMatch[1].trim() : "";
                              chromiumError = error;
                              chromiumExtraInfo = info;
                            });
                            //	_TMP_step_result = _TMP_step_result.replace(/^TIME\sFROM:\s(.*)\s\|\sTIME\sTO:\s(.*)\s\|\sTIME:\s(\d*)\s\|\sSIZE:\s([\d\.]*)\s\|\sERROR:\s(.*)/gm, '');
                          }

                          chromiumHar = _C_detail_step.harid
                            ? this.props.listData.res_id +
                              "." +
                              _C_detail_step.harid +
                              ".har"
                            : undefined;
                          chromiumLogcat = _C_detail_step.logcatid
                            ? this.props.listData.res_id +
                              "." +
                              _C_detail_step.logcatid +
                              ".logcat"
                            : undefined;

                          chromiumJpeg = _C_detail_step.jpegid
                            ? this.props.listData.res_id +
                              "." +
                              _C_detail_step.jpegid +
                              ".jpeg"
                            : undefined;

                          chromiumPDF = _C_detail_step.pdfid
                            ? this.props.listData.res_id +
                              "." +
                              _C_detail_step.pdfid +
                              ".pdf"
                            : undefined;

                          chromiumVideo =
                            _C_detail_step.mp4id &&
                            this.getAppContext().momentjs().unix() -
                              this.props.match.params.ts <
                              86400 * 60
                              ? this.props.listData.res_id +
                                "." +
                                _C_detail_step.mp4id +
                                ".mp4"
                              : undefined;

                          chromiumLmp4 =
                            _C_detail_step.lmp4id &&
                            this.getAppContext().momentjs().unix() -
                              this.props.match.params.ts <
                              86400 * 60
                              ? this.props.listData.res_id +
                                "." +
                                _C_detail_step.lmp4id +
                                ".lmp4"
                              : undefined;
                          if (chromiumLmp4) {
                            lmp4URL =
                              this.getAppContext()
                                .getApiStoreService()
                                .getCluster() +
                              this.getAppContext().conf.API_PATH +
                              "/utils/chromescreenstream/" +
                              this.props.match.params.probeuid +
                              "/" +
                              this.props.match.params.measureid +
                              "/" +
                              this.props.listData.bssid.replace(/:/g, "") +
                              "/" +
                              chromiumLmp4 +
                              "?token=" +
                              this.getAppContext().authHandler.getToken();
                          }

                          let objJpeg = undefined;
                          let objVideo = undefined;
                          let objPDF = undefined;

                          // ----------------------------------------- //
                          // Se bssid è NULL non visualizza le immagini.
                          // Nel file Measure_loc la stringa deve essere formattata: "Running on SSID Ethernet-Qv4zp, FREQUENCY 0, BSSID 00:00:00:00:00:00"
                          // diff Transit1_tester.pl Transit1_tester.pl.orig
                          // 85c85
                          // < print $LOGfh "Running on SSID ${I_cssid}, FREQUENCY ${I_chan}, BSSID ${I_bssid}\n";
                          // ---
                          // > print $LOGfh "Running on SSID ${I_cssid}\n";
                          // ----------------------------------------- //

                          if (this.props.listData.bssid) {
                            if (chromiumJpeg) {
                              objJpeg = {
                                url:
                                  this.getAppContext()
                                    .getApiStoreService()
                                    .getCluster() +
                                  this.getAppContext().conf.API_PATH +
                                  "/utils/chromescreenstream/" +
                                  this.props.match.params.probeuid +
                                  "/" +
                                  this.props.match.params.measureid +
                                  "/" +
                                  this.props.listData.bssid.replace(/:/g, "") +
                                  "/" +
                                  chromiumJpeg +
                                  "?token=" +
                                  this.getAppContext().authHandler.getToken(),
                                chromiumJpeg: chromiumJpeg,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }

                            if (chromiumPDF) {
                              objPDF = {
                                url:
                                  this.getAppContext()
                                    .getApiStoreService()
                                    .getCluster() +
                                  this.getAppContext().conf.API_PATH +
                                  "/utils/chromepdfstream/" +
                                  this.props.match.params.probeuid +
                                  "/" +
                                  this.props.match.params.measureid +
                                  "/" +
                                  this.props.listData.bssid.replace(/:/g, "") +
                                  "/" +
                                  chromiumPDF +
                                  "?token=" +
                                  this.getAppContext().authHandler.getToken(),
                                chromiumPDF: chromiumPDF,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }

                            if (chromiumVideo) {
                              objVideo = {
                                url:
                                  this.getAppContext()
                                    .getApiStoreService()
                                    .getCluster() +
                                  this.getAppContext().conf.API_PATH +
                                  "/utils/chromescreenstream/" +
                                  this.props.match.params.probeuid +
                                  "/" +
                                  this.props.match.params.measureid +
                                  "/" +
                                  this.props.listData.bssid.replace(/:/g, "") +
                                  "/" +
                                  chromiumVideo +
                                  "?token=" +
                                  this.getAppContext().authHandler.getToken(),
                                chromiumVideo: chromiumVideo,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }

                            if (lmp4URL != undefined) {
                              objVideo = {
                                url: lmp4URL,
                                chromiumLmp4: chromiumLmp4,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }
                          }

                          return (
                            <div className="m-0 p-3 bg-dark text-light">
                              {isChromium ? (
                                <div>
                                  <Row className="mb-2">
                                    {/* objJpeg.url.error */}
                                    {objJpeg && (
                                      <Col xs={4}>
                                        <div className="overlay">
                                          <img
                                            className="w-100 img-pointer"
                                            alt="sceenshot"
                                            src={objJpeg.url}
                                            onClick={() => {
                                              this.props._overlap_modal_img.open(
                                                objJpeg
                                              );
                                            }}
                                          />
                                        </div>
                                      </Col>
                                    )}
                                    <Col xs={objJpeg ? 8 : 12}>
                                      <Panel
                                        rounded
                                        className="bg-dark mb-4"
                                        bodyClassName="p-3"
                                      >
                                        <Row className="d-flex">
                                          <Col className="flex-grow-1">
                                            <pre className="body-pre text-light m-0">
                                              {chromiumInfo.map((elem, id) => {
                                                return (
                                                  <div key={id}>
                                                    {elem.render}
                                                  </div>
                                                );
                                              })}
                                              {/* <div>
                                                Time from :{" "}
                                                <strong>
                                                  {chromiumTimeFrom != ""
                                                    ? chromiumTimeFrom
                                                    : "-"}
                                                </strong>
                                              </div>
                                              <div>
                                                Time to :{" "}
                                                <strong>
                                                  {chromiumTimeTo != ""
                                                    ? chromiumTimeTo
                                                    : "-"}
                                                </strong>
                                              </div>
                                              <div>
                                                Elapsed time :{" "}
                                                <strong>
                                                  {chromiumTime != ""
                                                    ? chromiumTime + " ms"
                                                    : "-"}
                                                </strong>
                                              </div>
                                              <div>
                                                Downloaded size :{" "}
                                                <strong>
                                                  {chromiumSize != ""
                                                    ? chromiumSize + "K"
                                                    : "-"}
                                                </strong>
                                              </div> */}
                                            </pre>
                                          </Col>

                                          <Col
                                            className="align-self-end"
                                            style={{
                                              maxWidth: "fit-content",
                                            }}
                                          >
                                            {chromiumVideo != undefined ? (
                                              <div className="mb-2">
                                                <ReactOButton
                                                  className="w-100 text-left"
                                                  onClick={() => {
                                                    this.props._overlap_modal_video.open(
                                                      objVideo
                                                    );
                                                  }}
                                                  icon="file-video"
                                                >
                                                  Play video
                                                </ReactOButton>
                                              </div>
                                            ) : null}
                                            {chromiumLmp4 != undefined ? (
                                              <div className="mb-2">
                                                <ReactOButton
                                                  className="w-100 text-left"
                                                  onClick={() => {
                                                    fetch(lmp4URL)
                                                      .then((response) =>
                                                        response.text()
                                                      )
                                                      .then((url) => {
                                                        let parsedURL =
                                                          "https://" + url;
                                                        let objVideo = {
                                                          url: parsedURL,
                                                          chromiumLmp4:
                                                            chromiumLmp4,
                                                          bssid:
                                                            this.props.listData.bssid.replace(
                                                              /:/g,
                                                              ""
                                                            ),
                                                          // size: chromiumSize,
                                                        };

                                                        this.props._overlap_modal_video.open(
                                                          objVideo
                                                        );
                                                      });
                                                  }}
                                                  icon="file-video"
                                                >
                                                  Play video
                                                </ReactOButton>
                                              </div>
                                            ) : null}
                                            {chromiumLogcat != undefined ? (
                                              <div className="mb-2">
                                                <ReactOButton
                                                  className="w-100 text-left"
                                                  onClick={() => {
                                                    this.props.viewLogcat(
                                                      this.props.listData.bssid.replace(
                                                        /:/g,
                                                        ""
                                                      ),
                                                      chromiumLogcat
                                                    );
                                                  }}
                                                  icon="file-log"
                                                >
                                                  View .logcat
                                                </ReactOButton>
                                              </div>
                                            ) : null}
                                            {chromiumHar && (
                                              <div>
                                                <div className="mb-2">
                                                  <ReactOButton
                                                    className="w-100 text-left"
                                                    onClick={() => {
                                                      this.props.viewHar(
                                                        this.props.listData.bssid.replace(
                                                          /:/g,
                                                          ""
                                                        ),
                                                        chromiumHar
                                                      );
                                                    }}
                                                    icon="file-har"
                                                  >
                                                    View .har
                                                  </ReactOButton>
                                                </div>

                                                <div className="mb-2">
                                                  <ReactOButton
                                                    className="w-100 text-left"
                                                    onClick={() => {
                                                      this.props.downloadHar(
                                                        this.props.listData.bssid.replace(
                                                          /:/g,
                                                          ""
                                                        ),
                                                        chromiumHar
                                                      );
                                                    }}
                                                    icon="file-har"
                                                  >
                                                    Download .har
                                                  </ReactOButton>
                                                </div>
                                              </div>
                                            )}

                                            {chromiumPDF && objPDF && (
                                              <div className="mb-2">
                                                <ReactOButton
                                                  className="w-100 text-left"
                                                  onClick={() => {
                                                    window.open(objPDF.url);
                                                  }}
                                                  icon="file-pdf1"
                                                >
                                                  Download PDF
                                                </ReactOButton>
                                              </div>
                                            )}
                                          </Col>
                                        </Row>
                                      </Panel>
                                    </Col>
                                  </Row>

                                  <div>
                                    {chromiumError != "" ? (
                                      <pre className="body-pre text-light">
                                        ERROR: {chromiumError}
                                      </pre>
                                    ) : null}
                                    {chromiumExtraInfo != "" ? (
                                      <pre className="body-pre text-light">
                                        {chromiumExtraInfo}
                                      </pre>
                                    ) : null}
                                    {chromiumMsg != "" ? (
                                      <pre className="body-pre text-light">
                                        {chromiumMsg}
                                      </pre>
                                    ) : null}
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <pre className="body-pre text-light">
                                    {_TMP_step_result ? (
                                      this.props.match?.params.measureid
                                        .toLowerCase()
                                        .includes("teams") ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: _TMP_step_result.trim(),
                                          }}
                                        />
                                      ) : (
                                        _TMP_step_result.trim()
                                      )
                                    ) : (
                                      //    ? _TMP_step_result.trim()
                                      "No details available"
                                    )}
                                  </pre>
                                  <div className="pt-1">
                                    <div className="d-flex justify-content-end">
                                      {chromiumLogcat != undefined ? (
                                        <div className="mb-2 mr-3">
                                          <ReactOButton
                                            className="w-100 text-left"
                                            onClick={() => {
                                              this.props.viewLogcat(
                                                this.props.listData.bssid.replace(
                                                  /:/g,
                                                  ""
                                                ),
                                                chromiumLogcat
                                              );
                                            }}
                                            icon="file-log"
                                          >
                                            View .logcat
                                          </ReactOButton>
                                        </div>
                                      ) : null}

                                      {chromiumPDF && objPDF && (
                                        <div className="mb-2">
                                          <ReactOButton
                                            className="w-100 text-left"
                                            onClick={() => {
                                              window.open(objPDF.url);
                                            }}
                                            icon="file-log"
                                          >
                                            Download PDF
                                          </ReactOButton>
                                        </div>
                                      )}

                                      {chromiumVideo != undefined &&
                                      lmp4URL == undefined ? (
                                        <div className="mb-2 mr-3">
                                          <ReactOButton
                                            className="w-100 text-left"
                                            onClick={() => {
                                              this.props._overlap_modal_video.open(
                                                objVideo
                                              );
                                            }}
                                            icon="file-video"
                                          >
                                            Play video
                                          </ReactOButton>
                                        </div>
                                      ) : null}

                                      {lmp4URL != undefined ? (
                                        <div className="mb-2 mr-3">
                                          <ReactOButton
                                            className="w-100 text-left"
                                            onClick={() => {
                                              fetch(lmp4URL)
                                                .then((response) =>
                                                  response.text()
                                                )
                                                .then((url) => {
                                                  let parsedURL =
                                                    "https://" + url;
                                                  let objVideo = {
                                                    url: parsedURL,
                                                    chromiumLmp4: chromiumLmp4,
                                                    bssid:
                                                      this.props.listData.bssid.replace(
                                                        /:/g,
                                                        ""
                                                      ),
                                                    // size: chromiumSize,
                                                  };
                                                  this.props._overlap_modal_video.open(
                                                    objVideo
                                                  );
                                                });
                                            }}
                                            icon="file-video"
                                          >
                                            Play video
                                          </ReactOButton>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </ReactOCollapse>
                    ) : null}
                  </Col>
                </Row>
              );
            }
          );
        })}

        <Row noGutters className="phase-row bg-gray300">
          <Col>
            <Row
              style={{ cursor: "pointer" }}
              noGutters
              className={
                "phase-row-header" +
                (this.state._collapse_controllers["_FINAL_"] &&
                this.state._collapse_controllers["_FINAL_"].opened
                  ? " opened"
                  : "")
              }
              onClick={() => {
                if (this.state._collapse_controllers["_FINAL_"]) {
                  this.state._collapse_controllers["_FINAL_"].toggle();
                }
              }}
            >
              {this.getAppContext().media.isMobile ? null : <Col xs={1} />}

              <Col
                xs={8}
                className={
                  "header-phase align-self-center " +
                  this.getAppContext().media.isMobile
                    ? ""
                    : "pl-4"
                }
              >
                END OF MEASURE
              </Col>
              {/* <Col className="text-right">
                {this.state._collapse_controllers["_FINAL_"] &&
                this.state._collapse_controllers["_FINAL_"].opened ? (
                  <ReactOButton
                    // outline
                    className="ml-2"
                    size="md"
                    color="secondary"
                    icon="new-tab"
                    text
                    onClick={(e) => {
                      e.stopPropagation();
                      let _toSend = {
                        api: {
                          probeuid: this.props.match.params.probeuid,
                          measureid: this.props.match.params.measureid,
                          bssid: this.props.match.params.bssid,
                          ts: this.props.match.params.ts,
                        },
                        ref: {
                          name: "End of measure",
                          phase: "End",
                          originUrl: this.props.match.url,
                          selectedResult: this.props.selectedResult,
                          final: true,
                        },
                      };
                      this.viewStep(_toSend);
                    }}
                  />
                ) : null}
              </Col> */}
              <Col className="header-collapse-indicator align-self-center">
                <span
                  style={{ fontSize: "x-large" }}
                  className={
                    "title-2 text-muted pr-2 " +
                    (this.state._collapse_controllers["_FINAL_"] &&
                    this.state._collapse_controllers["_FINAL_"].opened
                      ? "icon-caret-up-outline"
                      : "icon-caret-down-outline")
                  }
                />
              </Col>
            </Row>
            <ReactOCollapse
              className="phase-row-body"
              onControllerReady={(_collapse_controller) => {
                this.setState((prev_state) => {
                  prev_state._collapse_controllers["_FINAL_"] =
                    _collapse_controller;
                  return prev_state;
                });
              }}
              onOpened={() => {
                this.setState((prev_state) => {
                  prev_state._collapse_controllers["_FINAL_"].opened = true;
                  return prev_state;
                });
              }}
              onClosed={() => {
                this.setState((prev_state) => {
                  prev_state._collapse_controllers["_FINAL_"].opened = false;
                  return prev_state;
                });
              }}
            >
              <pre className="body-pre m-0 p-3 bg-dark text-light">
                {this.props.listData.end
                  ? this.props.listData.end
                  : "No details available"}
              </pre>
            </ReactOCollapse>
          </Col>
        </Row>
      </div>
    );
  }
}

export default contextProvider(withRouter(ListView), {});
